import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "pdt-30" }
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center pdb-20" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, " Docs Mapping Screen ", -1)
const _hoisted_4 = {
  key: 1,
  class: "bordered-card bordered-card_secondary flex-row"
}
const _hoisted_5 = { class: "d-flex flex-column w-75" }
const _hoisted_6 = { class: "filters d-flex gap-4 flex-wrap flex-md-nowrap justify-content-between w-100 mb-20" }
const _hoisted_7 = { class: "d-flex gap-4 col-md-6 col-sm-12" }
const _hoisted_8 = { class: "small striped toggle no-underline fixed-table" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("thead", { class: "large large_padding" }, [
  /*#__PURE__*/_createElementVNode("tr", { class: "text-center" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "w-25" }, " Area "),
    /*#__PURE__*/_createElementVNode("th", { class: "w-25" }, " View ")
  ])
], -1)
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "cursor-pointer-hover" }
const _hoisted_12 = { class: "cursor-pointer-hover" }
const _hoisted_13 = { class: "d-flex flex-column w-25" }
const _hoisted_14 = { class: "scrollable-content" }
const _hoisted_15 = { class: "small mb-4 row-paddings text-black" }
const _hoisted_16 = { class: "checkbox document-row" }
const _hoisted_17 = { class: "checkbox-input" }
const _hoisted_18 = ["id", "value"]
const _hoisted_19 = ["for"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AlertsComponent = _resolveComponent("AlertsComponent")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_TextInput = _resolveComponent("TextInput")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_AlertsComponent, {
      info: $setup.info,
      success: $setup.success
    }, null, 8, ["info", "success"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("button", {
          class: "btn btn-primary",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.handleSave && $setup.handleSave(...args)))
        }, _toDisplayString($setup.loadingSubmit ? 'Saving...' : 'Save Changes'), 1)
      ])
    ]),
    ($setup.loading)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_SelectComponent, {
                  selectedOption: $setup.filters.Area,
                  "onUpdate:selectedOption": _cache[1] || (_cache[1] = ($event: any) => (($setup.filters.Area) = $event)),
                  options: $setup.areas,
                  "single-arrow": true,
                  customClass: "w-100 fs-xs ",
                  onChange: $setup.handleAreaChange
                }, null, 8, ["selectedOption", "options", "onChange"]),
                _createVNode(_component_TextInput, {
                  name: "mixed",
                  type: "text",
                  placeholder: "Search",
                  max: 50,
                  modelValue: $setup.filters.Search,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.filters.Search) = $event)),
                  customClass: "search fs-xs w-100",
                  onInput: $setup.handleSearchView
                }, null, 8, ["modelValue", "onInput"])
              ])
            ]),
            _createElementVNode("table", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.forms, (form) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: form.FormID,
                    class: _normalizeClass({
                            'cursor-pointer-hover': true,
                            'large': true,
                            'selected': $setup.selectedForm === form.FormID
                        }),
                    onClick: ($event: any) => ($setup.handleSelectedForm(form.FormID))
                  }, [
                    _createElementVNode("td", _hoisted_11, _toDisplayString(form?.Area), 1),
                    _createElementVNode("td", _hoisted_12, _toDisplayString(form?.View), 1)
                  ], 10, _hoisted_10))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createVNode(_component_TextInput, {
              name: "mixed",
              type: "text",
              placeholder: "Search for Documents",
              max: 50,
              modelValue: $setup.filters.Documents,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.filters.Documents) = $event)),
              customClass: "search w-100 mb-30",
              onInput: $setup.handleSearchDocument
            }, null, 8, ["modelValue", "onInput"]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("table", _hoisted_15, [
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.documents, (document) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: document.CodeID
                    }, [
                      _createElementVNode("td", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            id: document.CodeID.toString(),
                            onChange: _cache[4] || (_cache[4] = ($event: any) => ($setup.handleDocumentChange())),
                            class: "document-checkbox",
                            value: document.CodeID,
                            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.checkedDocuments) = $event))
                          }, null, 40, _hoisted_18), [
                            [_vModelCheckbox, $setup.checkedDocuments]
                          ]),
                          _createElementVNode("label", {
                            for: document.CodeID.toString()
                          }, _toDisplayString(document.Description), 9, _hoisted_19)
                        ])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
  ], 64))
}